<template>
  <div>
    <el-card class="mtf1">
      <div class="custom-flex-space-between">
        <div class="curMonth">
          <el-radio-group v-model="timeDimension" class="custom-elRadioGroup" text-color="#78bfcf" fill="#ffffff" @change="getData">
            <el-radio-button label="1">{{ $t('AirFreight.CurrentMonth') }}</el-radio-button>
            <el-radio-button label="2">{{ $t('AirFreight.CurrentQuarter') }}</el-radio-button>
            <el-radio-button label="3">{{ $t('AirFreight.CurrentYear') }}</el-radio-button>
          </el-radio-group>
        </div>
        <!-- <div class="custom-flex-center">
          <div class="ft14">{{ $t('AirFreight.ServiceType') }}</div>
          <div>
            <el-select v-model="circuitSelect" class="custom-input" size="small" :popper-append-to-body="true" @change="circuitChange">
              <el-option v-for="(item,index) in selectList" :key="index" :value="item.value" :label="item.label" />
            </el-select>
          </div>
        </div> -->
      </div>
      <el-divider />
      <el-row v-loading="loading" :gutter="10">
        <el-col :span="4">
          <div class="accumulatedL custom-flex-space-between overflowHidden" style="background: #ebf6ff">
            <div>
              <p class="label">{{ $t('AirFreight.TotalBLofShipment') }}</p>
              <div class="content">{{ formData.all }}</div>
            </div>
            <img src="@/assets/fms/GoodsAll.svg" class="svg-icon-1">
          </div>
        </el-col>
        <el-col :span="4">
          <div class="accumulatedL custom-flex-space-between overflowHidden" style="background: #ebfdee">
            <div>
              <p class="label">{{ $t('AirFreight.BLofShipmentGeneralCargo') }}</p>
              <div class="content">{{ formData.ordinary }}</div>
            </div>
            <img src="@/assets/fms/Goods.svg" class="svg-icon-2" style="padding:2px">
          </div>
        </el-col>
        <el-col :span="4">
          <div class="accumulatedL custom-flex-space-between overflowHidden" style="background: #ffefef">
            <div>
              <p class="label">{{ $t('AirFreight.BLofShipmentHazmatCargo') }}</p>
              <div class="content">{{ formData.dangerous }}</div>
            </div>
            <img src="@/assets/fms/GoodsDG.svg" class="svg-icon-3" style="padding:6px">
          </div>
        </el-col>
        <el-col v-if="formData.jobType==='AI'" :span="6">
          <div class="accumulatedR custom-flex border borderRadius">
            <div>
              <p class="label">{{ $t('AirFreight.CustomsNumber') }}</p>
              <div class="custom-flex-space-between">
                <img src="@/assets/fms/transport_status_1.png">
                <p class="content">{{ formData.customs }}</p>
              </div>
            </div>
          </div>
        </el-col>
        <el-col v-if="formData.jobType==='AI'" :span="6">
          <div class="accumulatedR custom-flex border borderRadius">
            <div>
              <p class="label">{{ $t('AirFreight.TransportNumber') }}</p>
              <div class="custom-flex-space-between">
                <img src="@/assets/fms/transport_status_2.png">
                <p class="content">{{ formData.transport }}</p>
              </div>
            </div>
          </div>
        </el-col>
        <el-col v-if="formData.jobType==='AE'" :span="6">
          <div class="accumulatedR custom-flex border borderRadius">
            <div>
              <p class="label">{{ $t('AirFreight.WeightGeneralCargoKGS') }}</p>
              <div class="custom-flex-space-between">
                <img src="@/assets/fms/transport_status_1.png">
                <p class="content">{{ formData.ordinaryWeight.toFixed(2).replace(/\.?0+$/, '') }}</p>
              </div>
            </div>
          </div>
        </el-col>
        <el-col v-if="formData.jobType==='AE'" :span="6">
          <div class="accumulatedR custom-flex border borderRadius">
            <div>
              <p class="label">{{ $t('AirFreight.WeightHazmatCargoKGS') }}</p>
              <div class="custom-flex-space-between">
                <img src="@/assets/fms/transport_status_2.png">
                <p class="content">{{ formData.dangerousWeight.toFixed(2).replace(/\.?0+$/, '') }}</p>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-row :gutter="10">
      <el-col :span="12">
        <el-card class="mt10 minheight350">
          <span class="fw600">{{ $t('AirFreight.ShipmentStatistics') }}</span>
          <div class="custom-flex-space-between mt16">
            <div class="customblue dianBlue custom-flex-center">{{ $t('AirFreight.BLofShipment') }}</div>
            <!-- <el-date-picker v-model="votePickerTime" class="custom-input" type="month" format="yyyy-MM" value-format="yyyyMM" :clearable="false" placeholder="月度" size="small" @change="voteChange" /> -->
          </div>
          <BarChart id="vote" ref="vote" v-loading="loadingLeft" :y-axis-min-interval="1" />
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="mt10 minheight350">
          <span class="fw600">{{ jobType==='AE' ? $t('AirFreight.WeightStatistics'):$t('AirFreight.AINumber') }}</span>
          <div class="custom-flex-space-between mt16">
            <div class="customred dianRed custom-flex-center">{{ jobType==='AE' ? $t('AirFreight.WeightKGS'):$t('AirFreight.BLofShipment') }}</div>
            <!-- <el-date-picker v-model="weightPickerTime" class="custom-input" type="month" format="yyyy-MM" value-format="yyyyMM" :clearable="false" placeholder="月度" size="small" @change="weightChange" /> -->
          </div>
          <BarChart id="weight" ref="weight" v-loading="loadingRight" :color="'#e66c68'" :y-axis-min-interval="jobType==='AE' ? null : 1" />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  GetDataStatistics,
  GetDataStatisticsJob,
  GetDataStatisticsWeight,
  GetDataStatisticsAIJob
} from '@/api/air/order/index'
import BarChart from '@/components/fms/barChart/index.vue'
import { parseTime } from '@/utils/index.js'
import i18n from '@/i18n/i18n'
export default {
  components: { BarChart },
  props: {
    jobType: {
      type: String,
      default: 'AE'
    }
  },
  data() {
    return {
      loading: false,
      loadingLeft: false,
      loadingRight: false,
      formData: {},
      formDataJob: {},
      formDataWeight: {},
      /** 周期 */
      timeDimension: '1',
      /** 业务类型 */
      // circuitSelect: 'AE',
      // selectList: [
      //   { value: 'AE', label: '空运出口' },
      //   { value: 'AI', label: '空运进口' }
      // ],
      votePickerTime: parseTime(new Date(), '{y}{m}'),
      weightPickerTime: parseTime(new Date(), '{y}{m}')
    }
  },
  computed: {},
  watch: {
    jobType (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getData()
      }
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.getData()
      // this.voteChange()
      // this.weightChange()
    },
    circuitChange() {
      this.getData()
      // this.voteChange()
      // this.weightChange()
    },
    async getData() {
      this.voteChange()
      this.weightChange()
      const params = {
        timeDimension: this.timeDimension,
        circuitSelect: this.jobType
      }
      this.loading = true
      const res = await GetDataStatistics(params)
      this.loading = false
      if (res && res.isSuccess) {
        this.formData = res.data
      }
    },
    async voteChange() {
      const params = {
        // month: this.votePickerTime,
        timeDimension: this.timeDimension,
        circuitSelect: this.jobType
      }
      this.loadingLeft = true
      const res = await GetDataStatisticsJob(params)
      this.loadingLeft = false
      if (res && res.isSuccess) {
        var data = res.data
        var dataName = [i18n.t('AirFreight.TotalBLofShipment'), i18n.t('AirFreight.BLofShipmentGeneralCargo'), i18n.t('AirFreight.BLofShipmentHazmatCargo')]
        var dataSource = [data.all, data.ordinary, data.dangerous]
        this.$refs.vote.chartInit(dataName, dataSource)
      }
    },
    async weightChange() {
      if (this.jobType === 'AE') {
        const params = {
          // month: this.weightPickerTime,
          timeDimension: this.timeDimension,
          circuitSelect: this.jobType
        }
        this.loadingRight = true
        const res = await GetDataStatisticsWeight(params)
        this.loadingRight = false
        if (res && res.isSuccess) {
          const dataName = [i18n.t('AirFreight.Total'), i18n.t('AirFreight.WeightGeneralCargo'), i18n.t('AirFreight.WeightHazmatCargo')]
          const dataSource = [
            res.data.all.toFixed(2),
            res.data.ordinary.toFixed(2),
            res.data.dangerous.toFixed(2)
          ]
          this.$refs.weight.chartInit(dataName, dataSource)
        }
      } else if (this.jobType === 'AI') {
        const params = {
          // month: this.weightPickerTime,
          timeDimension: this.timeDimension,
          circuitSelect: this.jobType
        }
        this.loadingRight = true
        const res = await GetDataStatisticsAIJob(params)
        this.loadingRight = false
        if (res && res.isSuccess) {
          const dataName = ['PVG', 'PEK', 'TSN', 'CAN', i18n.t('AirFreight.Other')]
          const dataSource = [0, 0, 0, 0, 0]
          res.data.forEach((el) => {
            dataSource[dataName.indexOf(el.name)] = el.value
          })
          this.$refs.weight.chartInit(dataName, dataSource)
        }
      }
    }
  }
}
</script>
<style scoped>
.custom-input {
  border: none;
  width: 200px;
}
.custom-input >>> input {
  border: none;
  background: #f6f6f8;
}
.ft14 {
  font-size: 14px;
}
.mtf1 {
  margin-top: -1px;
  border-top: #fff;
}
.mt10 {
  margin-top: 10px;
}
.mt16 {
  margin-top: 16px;
}
.fw600 {
  font-weight: 600;
}
.minheight350 {
  min-height: 350px;
}
.border {
  border: 1px solid #e5e7eb;
}
.borderRadius {
  border-radius: 10px;
}
.dianBlue::before {
  content: '';
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #58c6e4;
  border-radius: 50%;
  margin-right: 6px;
  margin-bottom: 2px;
}
.dianRed::before {
  content: '';
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #e66c68;
  border-radius: 50%;
  margin-right: 6px;
  margin-bottom: 2px;
}
.curMonth {
  padding: 4px;
  background: #f6f6f8;
}
.accumulatedL,
.accumulatedR {
  padding: 16px 24px;
  height: 88px;
}
.accumulatedL .label,
.accumulatedR .label {
  font-size: 12px;
  font-weight: 400;
  color: #4b5563;
  white-space: nowrap;
}
.accumulatedL .content {
  font-size: 26px;
  font-weight: 600;
  color: #111827;
  margin-top: 14px;
}
.accumulatedR .content {
  font-size: 26px;
  font-weight: 600;
  color: #111827;
  margin: 14px 0 0 8px;
}
.accumulatedL img {
  width: 64px;
  height: 64px;
  display: inline-block;
}
.accumulatedR img {
  width: 30px;
  height: 30px;
  display: inline-block;
  margin-top: 14px;
}
.overflowHidden{
  overflow: hidden;
}
.svg-icon-1 {
  position: relative;
  left: 100px;
  filter: drop-shadow(#64b0ee -100px 0);
}
.svg-icon-2 {
  position: relative;
  left: 100px;
  filter: drop-shadow(#6db97a -100px 0);
}
.svg-icon-3 {
  position: relative;
  left: 100px;
  filter: drop-shadow(#ec8282 -100px 0);
}
</style>
